/* Cause Architecture — Horizon Theme Integration (PDP + Cart + Deep-link) */

(() => {
  // Common function to set all cause cookies
  function setCauseCookies(name, shortCode, defaultShortCode) {
    setCookie('user_cause_name', name, 30);
    setCookie('user_cause', shortCode, 30);
    setCookie('default_cause', defaultShortCode, 30);
  }


  function isPWA() {
      if (typeof window !== "undefined") {
      return (
        window.matchMedia("(display-mode: standalone)").matches ||
        // @ts-ignore
        (typeof window.navigator['standalone'] !== "undefined" && window.navigator['standalone'] === true) ||
        window.navigator.userAgent?.includes("PWAShell")
      );
    }
    return false; // Handle the case when window is undefined
  }
  

  function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }
  // Use global variables from cause-init.liquid
  var defaultShortCode = window.DEFAULT_CAUSE_HANDLE;
  var defaultCause = window.DEFAULT_CAUSE_NAME;
  var causeMap = window.CAUSE_MAP || {};

  // Helper functions
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c && c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c && c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Only set cookies if not already set or if default changed
  var cookieShortCode = getCookie('user_cause');
  var cookieName = getCookie('user_cause_name');
  var defaultCauseCookie = getCookie('default_cause');
  // Sanitize cookie values - remove any double quotes
  if (cookieShortCode && cookieShortCode.includes('"')) {
    cookieShortCode = cookieShortCode.replace(/"/g, '');
    setCookie('user_cause', cookieShortCode, 30);
  }

  // If logged in and customer has a cause, do nothing (block JS will handle UI)
  //commenting out the code as if user is logged in it was not updating the default cause OS-6978
  // if (window.IS_LOGGED_IN && window.CUSTOMER_CAUSE_HANDLE) {
  //   return;
  // }

  // Guest logic: set cookies if missing or default changed
  var storedShortCode = null;
  if (!cookieShortCode || !cookieName) {
    try {
      storedShortCode = localStorage.getItem('user_cause');
    } catch (e) {}
    //Set data from local storage if cookie missing or existing users
    if (storedShortCode) {
      // Remove single and double quotes from stored short code
      storedShortCode = storedShortCode.replace(/["']/g, '');
      // Map short code to name using causeMap
      var mappedName = causeMap[storedShortCode] ? causeMap[storedShortCode] : defaultCause;
      mappedName = mappedName.replace(/&#39;/g, "'");
      setCauseCookies(mappedName, storedShortCode, defaultShortCode);
      // Remove localStorage value after successful transfer to cookies
      try {
        localStorage.removeItem('user_cause');
      } catch (e) {}
    } else {
      setCauseCookies(defaultCause, defaultShortCode, defaultShortCode);
    }
  } else if (defaultCauseCookie && defaultCauseCookie !== defaultShortCode) {
    // If user selection matches old default, update to new default
    if (cookieShortCode === defaultCauseCookie) {
      setCauseCookies(defaultCause, defaultShortCode, defaultShortCode);
    } else {
      // Always update default_cause cookie to new default
      setCookie('default_cause', defaultShortCode, 30);
    }
  }

  var welcomeJourneyCause = getCookie('user_cause_wj');
  var welcomeJourneyCauseName = getCookie('user_cause_name_wj');

  if (welcomeJourneyCause && isPWA()) {
    setCookie('user_cause', welcomeJourneyCause, 30);
    setCookie('user_cause_name', welcomeJourneyCauseName || '', 30);
    applyCause(welcomeJourneyCause);

    deleteCookie('user_cause_wj');
    deleteCookie('user_cause_name_wj');
  }

    const COOKIE = 'user_cause';
    const MAX_AGE = 60 * 60 * 24 * 30; // 30 days

    const params = new URLSearchParams(window.location.search);
    const urlCause = params.get('cause'); // short_code or handle

    if (urlCause) {
        setCookie('user_cause_name', window.CAUSE_MAP[urlCause], 30);
        setCookie('user_cause', urlCause, 30);
        if (getCookie('user_cause_wj')) {
          setCookie('user_cause_wj', urlCause, 30);
        }
        if (getCookie('user_cause_name_wj')) {
          setCookie('user_cause_name_wj', window.CAUSE_MAP[urlCause], 30);
        }
    }
  
    // ---- Utilities
    // const getCookie = (name) =>
    //   document.cookie.split('; ').find(r => r.startsWith(name + '='))?.split('=')[1] || '';
  
    // function setCookie(name, value, days) {
    //     var expires = '';
    //     if (days) {
    //       var date = new Date();
    //       date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    //       expires = '; expires=' + date.toUTCString();
    //     }
    //     document.cookie = name + '=' + (value || '') + expires + '; path=/';
    //   }
  
    const postJSON = async (url, body) => {
      const r = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body || {})
      });
      if (!r.ok) throw new Error(`${url} ${r.status}`);
      return r.json();
    };
  
    const getJSON = async (url) => {
      const r = await fetch(url, { method: 'GET' });
      if (!r.ok) throw new Error(`${url} ${r.status}`);
      return r.json();
    };
  
    const cartUpdateAttributes = async (attrs) => {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        });
      } catch (e) { console.warn('cart attrs update failed', e); }
    };
  
    // ---- Apply resolved cause everywhere
    async function applyCause(charity_handle,welcome = false) {
      if(charity_handle) {
    
    //   if (!resolved?.charity_handle) return;
  
    //   // 1) Cookie
    //   setCookie(COOKIE, resolved.charity_handle);
      // 2) Cart attributes (string values)
      if(!welcome) {
        await updateAllLineItemProperties({
          _benefit_unit: window.CAUSE_MAP_OBJ[charity_handle]?.benefit_unit || '1',
          _cause: window.CAUSE_MAP_OBJ[charity_handle]?.short_code || '1',
        });
      }
  
      // 3) Persist customer metafield when logged in (no-op if not logged)
      try {
        // Check if the user is logged in and get the customer ID
        const loggedInCustomerId = window.CUSTOMER_ID || null; // Ensure this variable is available globally
    
        if (!loggedInCustomerId) {
          return;
        }
    
        // Construct the URL
        const url = `/apps/cause/select`;
    
        // Make the POST request with the charity_handle and customer_id in the body
        await postJSON(url, {
          charity_handle: charity_handle,
          logged_in_customer_id: loggedInCustomerId, // Pass the customer ID in the body
        });
      } catch (e) {}
    }
    }

    window.applyCause = applyCause;
  
    // ---- Resolve precedence on every page
    (async function resolveAndInit() {
    //   try {
    //     const params = new URLSearchParams(window.location.search);
    //     const urlCause = params.get('cause'); // short_code or handle
    //     const customerCause = window.CUSTOMER_CAUSE_HANDLE || null;
    //     const cookieCause = decodeURIComponent(getCookie(COOKIE) || '');
    //     const defaultHandle = window.DEFAULT_CAUSE_HANDLE || null;
  
    //     // 1) URL param takes precedence
    //     if (urlCause) {
    //       const res = await postJSON('/apps/cause/resolve', { short_code: urlCause });
    //       if (res?.active) {
    //         await applyCause(res);
    //         return;
    //       }
    //     }
  
    //     // 2) Logged-in customer selection (over cookie/default)
    //     if (window.IS_LOGGED_IN && customerCause && customerCause !== cookieCause) {
    //       const res = await postJSON('/apps/cause/resolve', { handle: customerCause });
    //       if (res?.active) {
    //         await applyCause(res);
    //         return;
    //       }
    //     }
  
    //     // 3) Existing cookie → refresh Max-Age
    //     if (cookieCause) {
    //       setCookie(COOKIE, cookieCause);
    //       return;
    //     }
  
    //     // 4) No cookie → set the site default into cookie
    //     if (defaultHandle) {
    //       const res = await postJSON('/apps/cause/resolve', { handle: defaultHandle });
    //       if (res?.active) { await applyCause(res); return; }
    //     }
    //     // Fallback: call default endpoint if metafield isn’t set
    //     const def = await getJSON('/apps/cause/default');
    //     if (def?.active) await applyCause(def);
    //   } catch (e) {
    //     console.warn('cause init failed', e);
    //   }

    })();
  
    // ============================= PDP PREVIEW =============================
    // Displays: “This item funds <units> <benefitText>” in an element:
    // <div data-cause-preview></div>
    // Hook: variant change (Horizon/Dawn: listen to both change + custom events)
  
    function getCookieHandle() {
      let handle = decodeURIComponent(getCookie(COOKIE) || '');
      // Remove any double quotes from the handle
      if (handle.includes('"')) {
        handle = handle.replace(/"/g, '');
        setCookie(COOKIE, handle, 30);
      }
      return handle;
    }
  
    async function computePdpPreview(variantId, unitPrice) {
    
      const handle = getCookieHandle();
      let netlify_domain = window.netlify_function_domain;  
      if (!handle || !variantId || !Number.isFinite(unitPrice)) return;
      try {
        const res = await postJSON(`${netlify_domain}/.netlify/functions/cause-compute-variant`, {
          variantId,
          unitPrice,
          charityHandle: handle
        });
  
        // Select all divs with the class 'charity-message-block'
        const charityMessageBlocks = document.querySelectorAll('div.charity-message-block');
  
        // Example: Iterate over each block and log it
        charityMessageBlocks.forEach(block => {
          block.innerHTML = `<p>Provides ${res.donationUnits} ${res.benefitText || 'benefits'} to ${res.charityName || 'handle'}</p>`;
        });


    
        //create hidden input to the form to pass data to checkout
        const params = {
          handle: handle,
          benefitUnit: res.benefitUnit,
          sharePercentage: res.sharePercentage || '20',
          costToShip: res.costToShip || '59',
          oc: res.oc || '',
        };

        window.addHiddenInputsToCartForm(params)
  
      } catch (e) {
        console.warn('compute-variant failed', e);
      }
    }
  
    // Variant change glue for Horizon/Dawn-like themes
    function getCurrentVariantFromForm(form) {
      // Prefer hidden input name="id"
      const idInput = form?.querySelector('input[name="id"]');
      const variantNumericId = idInput?.value;
      if (!variantNumericId) return null;
      return `gid://shopify/ProductVariant/${variantNumericId}`;
    }
  
    function getUnitPriceFromPage() {
      // Prefer an element with a data-amount attribute you can add in Liquid.
      // If your theme uses money-format HTML, adapt this function to parse.
      const el = document.querySelector('[data-product-price][data-amount]');
      const priceElement = document.querySelector(".price[data-price]");
      if (priceElement) return Number(priceElement.getAttribute("data-price"));
      // Fallback: try meta price if you expose it yourself
      return NaN;
    }
  
    function bindPdp() {
      const productForm = document.querySelector('form[action*="/cart/add"]');
      //check for input with with id as is_pdp and value as true
      const isPdpInput = document.querySelector('input#is_pdp[name="is_pdp"][value="true"]');
      if(!isPdpInput) return;
    
      const trigger = async () => {
        const gid = getCurrentVariantFromForm(productForm);
        const price = getUnitPriceFromPage();
        await computePdpPreview(gid, price);
      };
  
      // Initial render
      trigger();
  
      // Change on variant select input
      productForm.addEventListener('change', (e) => {
        if (e.target && (e.target.name === 'id' || e.target.closest('variant-radios') || e.target.closest('variant-selects'))) {
          trigger();
        }
      });
  
      // Some themes dispatch custom events
      document.addEventListener('variant:change', trigger);
      document.addEventListener('product:variant-change', trigger);
    }
  
    // ============================= CART PREVIEW =============================
    // Displays: <div data-cause-cart-preview></div> near checkout button
    let cartPreviewInFlight = false;
    let cartPreviewQueued = false;
    let cartBindingsInitialized = false;
    /** @type {MutationObserver | null} */
    let cartRootObserver = null;

    async function computeCartPreview() {
      const _path = window.location.pathname;
      if (!_path.includes('/cart') && !_path.includes('/products/')) return;

      if (cartPreviewInFlight) {
        cartPreviewQueued = true;
        return;
      }

      cartPreviewInFlight = true;
      const handle = getCookieHandle();
      const charityMessageCartBlock = document.getElementById('charity-message-cart-block');

      // Failsafe timeout to prevent stuck loading
      let loadingFailsafe = null;
      if (charityMessageCartBlock) {
        loadingFailsafe = setTimeout(() => {
          charityMessageCartBlock.classList.remove('loading');
        }, 5000);
      }
  
      try {
        if (!handle) return;
        
        const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' }})).json();
        
        //skip gift card items from the cart items
        cart.items = cart.items.filter(item => !item.gift_card);
        const lines = (cart.items || []).map(it => ({
          variantId: `gid://shopify/ProductVariant/${it.variant_id}`,
          quantity: it.quantity,
          // Shopify cart.js price is in cents; convert to your unit (pre-tax if you need)
          perUnitPrice: it.price / 100
        }));
        if (!lines.length)
        {  
          // const charityMessageCartBlock = document.getElementById('charity-message-cart-block');
          if(charityMessageCartBlock) {
            charityMessageCartBlock.classList.add('d-none');
            charityMessageCartBlock.classList.remove('loading');
            charityMessageCartBlock.innerHTML = '';
          }
          return;
        }
  
        let netlify_domain = window.netlify_function_domain;  
        // const res = await postJSON(`${netlify_domain}/.netlify/functions/cause-compute-cart`, { lines, charityHandle: handle });

        const res = await postJSON(`${netlify_domain}/.netlify/functions/cause-compute-cart`, {
          lines,
          charityHandle: handle
        });

  
        // const el = document.querySelector('[data-cause-cart-preview]');
        // if (el && typeof res?.totalUnits !== 'undefined') {
        //   el.textContent = `This order funds ${res.totalUnits} ${res.benefitText || 'benefits'}.`;
        // }

        //get element by id charity-message-cart-block and update its inner html
        // const charityMessageCartBlock = document.getElementById('charity-message-cart-block');
        if (charityMessageCartBlock && typeof res?.totalUnits !== 'undefined') {
          charityMessageCartBlock.classList.remove('loading');
          charityMessageCartBlock.innerHTML = `<span>Provides ${res.totalUnits} ${res.benefitText || 'benefits'} to ${res.charityName || 'handle'}. Change <a class="changeCausePartnerBag" href="#" id="open-impact-drawer-link">cause partner?</a></span>`;
          // Add event listener to open impact drawer
          setTimeout(() => {
            const impactLink = document.getElementById('open-impact-drawer-link');
            if (impactLink) {
              impactLink.addEventListener('click', function(e) {
                e.preventDefault();
                const cartDrawer = /** @type {any} */ (document.querySelector('cart-drawer-component'));
                if (cartDrawer) cartDrawer.close();
                if (window.openImpactDrawer) {
                  window.openImpactDrawer();
                } else {
                  document.dispatchEvent(new CustomEvent('openImpactDrawer'));
                }
                document.addEventListener('impactDrawerClosed', function reopenCart() {
                  document.removeEventListener('impactDrawerClosed', reopenCart);
                  if (cartDrawer) cartDrawer.open();
                });
              });
            }
          }, 0);
          //remove d-none class from the element
        } else if(charityMessageCartBlock) {
          charityMessageCartBlock.classList.add('d-none');
          charityMessageCartBlock.classList.remove('loading');
          charityMessageCartBlock.innerHTML = '';
        }
  
        // // Persist attributes so checkout & notifications can read them
        // await cartUpdateAttributes({
        //   charity_handle: handle,
        //   charity_name: document.querySelector('[data-cause-name]')?.textContent || '',
        //   donation_units_preview: String(res.totalUnits ?? 0),
        //   benefit_text: res.benefitText || 'benefits'
        // });
      } catch (e) {
        console.warn('compute-cart failed', e);
      } finally {
        if (loadingFailsafe) {
          clearTimeout(loadingFailsafe);
        }
        cartPreviewInFlight = false;
        if (cartPreviewQueued) {
          cartPreviewQueued = false;
          setTimeout(computeCartPreview, 75);
        }
      }
    }

    window.computeCartPreview = computeCartPreview;
  
    function bindCart() {
        //check for input with with id as is_cart and value as true
      const isCartInput = document.querySelector('input#is_cart[name="is_cart"][value="true"]');
      if(!isCartInput) return;

      // Run on cart page load
      computeCartPreview();

      if (cartBindingsInitialized) {
        // Some themes render cart root lazily; try attaching observer later if needed.
        if (!cartRootObserver) {
          const lazyCartRoot = document.querySelector('cart-items, [data-cart-items], form[action*="/cart"]');
          if (lazyCartRoot) {
            cartRootObserver = new MutationObserver(() => { setTimeout(computeCartPreview, 50); });
            cartRootObserver.observe(lazyCartRoot, { childList: true, subtree: true });
          }
        }
        return;
      }

      cartBindingsInitialized = true;
  
      // Recompute on quantity changes (common input name in many themes)
      document.addEventListener('change', (e) => {
        if (e.target && (e.target.name === 'updates[]' || e.target.closest('[data-quantity-input]'))) {
          // Give the theme time to update cart first
          setTimeout(computeCartPreview, 250);
        }
      });
  
      // If theme emits a custom event after cart refresh
      document.addEventListener('cart:refresh', () => setTimeout(computeCartPreview, 50));
  
      // Mutation observer fallback (if cart DOM is updated by XHR)
      const cartRoot = document.querySelector('cart-items, [data-cart-items], form[action*="/cart"]');
      if (cartRoot && !cartRootObserver) {
        cartRootObserver = new MutationObserver(() => { setTimeout(computeCartPreview, 50); });
        cartRootObserver.observe(cartRoot, { childList: true, subtree: true });
      }
    }

    /**
     * Bulk-updates properties on all line items.
     * @param {Object} newProps - Properties to set (e.g., { "Gift wrap": "Yes" }).
     * @param {Object} options  - { merge: true } to merge with existing properties.
     */
    async function updateAllLineItemProperties(newProps, { merge = true } = {}) {
        const cart = await getCart();
        const lines = cart.items || [];
    
        // Process sequentially to minimize race conditions and avoid duplicate merges
        for (const line of lines) {
            const existing = line.properties || {};
            const properties = merge ? { ...existing, ...newProps } : { ...newProps };
        
            // To REMOVE a property, set it to null or empty string '' (see notes below)
            // e.g. properties["Gift wrap"] = '';
        
            await updateLinePropertiesByKey(line.key, line.quantity, properties);
        }
    
        // Return fresh cart
        return getCart();
    }

    async function getCart() {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Failed to fetch cart');
        return res.json();
    }

    async function updateLinePropertiesByKey(itemKey, quantity, properties) {
        const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
            id: itemKey,          // or use "line": 2 to target by index
            quantity: quantity,    // Include quantity in the request body
            properties           // { Engraving: "New text", "Gift wrap": "No" }
            })
        });
        if (!res.ok) throw new Error('Failed to change line item');
        return res.json();
    }
      
  
    // ---- Designer / product → cause association (mirrors Next.js generalConstants.designer_cause_association)
    var DESIGNER_CAUSE_ASSOCIATION = {
      "hellessy": "cancercartel",
      "girlsmusthave": "cancercartel",
      "adriana-cotton-maxi-dress-red": "cancercartel",
      "marla-wrap-cotton-skirt-black": "cancercartel",
      "marla-wrap-cotton-skirt-red": "cancercartel",
      "adriana-cotton-maxi-dress-black": "cancercartel",
      "gigi-wrap-cotton-skirt-red": "cancercartel",
      "irina-cotton-shirt-black": "cancercartel",
      "amelie-silk-pants-black": "cancercartel",
      "irina-cotton-shirt-red": "cancercartel",
      "sasha-bandeau-bikini-top-gold": "cancercartel",
      "ara-high-waist-bikini-bottom-gold": "cancercartel",
      "ara-high-waist-bikini-bottom-red": "cancercartel",
      "ara-high-waist-bikini-bottom-black": "cancercartel",
      "nath-bandeau-bikini-top-black": "cancercartel",
      "laila-bandeau-bikini-top-black": "cancercartel",
      "raquel-bow-bandeau-one-piece-swimsuit-black": "cancercartel",
      "angela-ruffled-bustier-one-piece-swimsuit-black": "cancercartel",
      "joan-ruched-one-piece-swimsuit-black": "cancercartel",
      "raquel-bow-bandeau-one-piece-swimsuit-white": "cancercartel",
      "mia-high-waist-bikini-bottom-black": "cancercartel",
      "harper-high-waist-bikini-bottom-black": "cancercartel",
      "sasha-bandeau-bikini-top-black": "cancercartel",
      "raquel-bow-bandeau-one-piece-swimsuit-gold": "cancercartel",
      "laila-bandeau-bikini-top-red": "cancercartel",
      "gaelle-jacquard-one-piece-swimsuit-black": "cancercartel",
      "nantucket-mini-beach-tote-bag-pink-gold": "wfwi",
      "palm-beach-medium-tote-bag-natural-navy": "wfwi",
      "nantucket-medium-beach-tote-bag-navy-white": "wfwi",
      "laren-wide-leg-pants-paprika-candy-pink": "wfwi",
      "mini-beach-tote-sky-latte": "wfwi",
      "lona-shirt-paprika-candy-pink": "wfwi",
      "nako-flat-sandal-paprika-candy-pink-mix": "wfwi",
      "lona-shirt-paprika-sky": "wfwi",
      "reka-espadrille-flat-paprika-natural": "wfwi",
      "beach-basket-tote-bag-natural-paprika-light-gold": "wfwi",
      "laren-wide-leg-pants-paprika-sky": "wfwi",
      "reta-silk-scarf-paprika-candy-pink": "wfwi",
      "nako-flat-sandal-sky-sky-mix": "wfwi",
      "ricia-95-platform-sandal-latte-natural": "wfwi",
      "avenue-pouch-natural-latte": "wfwi",
      "small-bon-bon-bucket-bag-natural-paprika-candy-pink-mix-light-gold": "wfwi",
      "bon-bon-fringe-bucket-bag-natural-candy-pink-mix-light-gold": "wfwi",
      "ricia-95-platform-sandal-candy-pink-natural": "wfwi",
      "diamond-top-handle-bag-natural-candy-pink-gold": "wfwi",
      "reta-silk-scarf-paprika-sky": "wfwi",
      "alizze-kb-85-black": "wfwi",
      "amel-50-macaron-crystal": "wfwi",
      "lexy-0jc5002bu-e93-light-brown": "wfwi",
      "saeda-100-sunset-mix-crystal": "wfwi",
      "ixia-95-latte": "wfwi",
      "bon-bon-bckt-e-w-sm-rose-antique-silver": "wfwi",
      "amel-50-biscuit": "wfwi",
      "verona-ballet-pink-crystal": "wfwi",
      "romy-60-black": "wfwi",
      "bon-bon-bckt-e-w-latte-gold": "wfwi",
      "lorea-0jc5001b-e13-gradient-brown": "wfwi",
      "bon-bon-pink-mix": "wfwi",
      "bing-100-pink-mix": "wfwi",
      "verona-black": "wfwi",
      "diamond-tophandle-black-gold": "wfwi",
      "romy-85-rose": "wfwi",
      "lorea-0jc5001b-e8g-gradient-grey": "wfwi",
      "gal-130-wedge-natural-ecru": "wfwi",
      "diamond-tilda-loafer-black": "wfwi",
      "romy-60-rattan": "wfwi",
      "bon-bon-bckt-e-w-black-antique-silver": "wfwi",
      "addie-pearl-black": "wfwi",
      "amel-50-black": "wfwi",
      "lexy-0jc5002bu-e81-dark-grey-polar": "wfwi",
      "lorea-0jc5001b2-e13-gradient-brown-2": "wfwi",
      "bon-bon-bckt-e-w-sm-latte-gold": "wfwi",
      "diamond-tilda-flat-black": "wfwi",
      "alizze-kb-85-taupe": "wfwi",
      "bing-100-macaron-mix": "wfwi",
      "diamond-tophandle-taupe-gold": "wfwi",
      "ixia-95-black": "wfwi",
      "bon-bon-bckt-e-w-sm-black-antique-silver": "wfwi",
      "nari-flat-black-anthracite": "wfwi",
      "cycas-ab-50-black": "wfwi",
      "pandora-jacquard-midi-dress-malachite": "d4s",
      "satin-bias-cap-sleeve-maxi-dress-olive": "wef",
      "wool-twill-two-button-blazer-olive": "wef",
      "pinstripe-stretch-wool-sleeveless-vest-midi-dress-navy-pinstripe": "wef",
      "wool-cashmere-shrunken-crewneck-sweater-olive": "wef",
      "seasonless-wool-double-breasted-chelsea-blazer-taupe": "wef",
      "seasonless-wool-single-pleat-wide-leg-trousers-taupe": "wef",
      "satin-bias-cap-sleeve-maxi-dress-black": "wef",
      "wool-twill-tailored-midi-dress-black": "wef",
      "seasonless-wool-double-breasted-blazer-black": "wef",
      "seasonless-wool-wide-leg-trousers-black": "wef",
      "seasonless-wool-shallow-v-neck-waistcoat-black": "wef",
      "seasonless-wool-single-button-blazer-black": "wef",
      "woven-satin-short-sleeve-top-taupe": "wef",
      "satin-bias-high-rise-midi-skirt-taupe": "wef",
      "tailored-twill-cap-sleeve-mini-dress-black": "wef",
      "satin-bias-long-sleeve-crewneck-top-black": "wef",
      "satin-bias-high-rise-midi-skirt-black": "wef",
      "wool-cashmere-polo-sweater-cream": "wef",
      "seasonless-wool-tailored-slim-ankle-trousers-black": "wef",
      "stretch-wool-slim-knit-turtleneck-black": "wef",
      "wool-cashmere-polo-sweater-navy": "wef",
      "stretch-tencel-knit-long-sleeve-crewneck-sweater-ochre": "wef",
      "chantecaille-philanthropy-cheek-shade-bee-86143": "cancercartel",
      "chantecaille-philanthropy-cheek-shade-coral-86141": "cancercartel",
      "sisleyparis-phyto-lipdelight-53907": "cancercartel",
      "sisleyparis-lorchideehighlighterblush-20761": "cancercartel",
      "jolly-bijou-amethyst-sundial-earrings-888214": "cancercartel",
      "jolly-bijou-tourmaline-mini-barre-ear-cuffs-888227": "cancercartel",
      "jolly-bijou-sapphire-sundial-pendant-necklace-888229": "cancercartel",
      "jolly-bijou-diamond-gemstone-open-square-earrings-888215": "cancercartel",
      "jolly-bijou-sapphire-otto-mini-huggies-888221": "cancercartel",
      "jolly-bijou-tourmaline-sundial-earrings-888213": "cancercartel",
      "chantecaille-liquid-lumiere-86147": "cancercartel",
      "chantecaille-cheek-gelee-86149": "cancercartel",
      "jolly-bijou-topaz-otto-mini-huggies-888219": "cancercartel",
      "jolly-bijou-diamond-open-square-earrings-888248": "cancercartel",
      "jolly-bijou-diamond-multicolor-enamel-chevron-pendant-necklace-888231": "cancercartel",
      "jolly-bijou-topaz-sapphire-pod-earrings-888225": "cancercartel",
      "jolly-bijou-pink-tourmaline-barre-ear-cuffs-888224": "cancercartel",
      "jolly-bijou-diamond-chevron-earrings-888216": "cancercartel",
      "sisleyparis-phyto-blushtwist-21779": "cancercartel",
      "jolly-bijou-citrine-opal-moon-pendant-necklace-888233": "cancercartel",
      "la-perla-silk-chemise-787035": "cancercartel",
      "jolly-bijou-green-purple-sapphire-pod-earrings-888226": "cancercartel",
      "jolly-bijou-tourmaline-otto-pinky-ring-1020315": "cancercartel",
      "colette-jewelry-pink-enamel-band-476047": "cancercartel",
      "jolly-bijou-london-blue-topaz-pod-signet-ring-1018925": "cancercartel",
      "jolly-bijou-london-blue-topaz-pod-pendant-necklace-1018922": "cancercartel",
      "jolly-bijou-topaz-otto-ring-888239": "cancercartel",
      "natori-sapphire-yin-yang-shangri-la-stud-earrings-7050377920648": "cancercartel",
      "natori-sapphire-yin-yang-shangri-la-knot-pendant-necklace-7050378150024": "cancercartel",
      "chantecaille-luminescent-eye-shade-195599": "cancercartel",
      "natori-sapphire-brush-stroke-shangri-la-half-eternity-ring-7050378379400": "cancercartel",
      "jolly-bijou-diamond-gemstone-open-square-ring-888237": "cancercartel",
      "natori-sapphire-brush-stroke-shangri-la-pendant-necklace-7050378248328": "cancercartel",
      "natori-sapphire-brush-stroke-shangri-la-stud-earrings-7050378051720": "cancercartel",
      "jolly-bijou-sapphire-full-moon-ring-888241": "cancercartel",
      "sisleyparis-phyto-levresperfectlipliner-20779": "cancercartel",
      "jolly-bijou-amethyst-otto-ring-888240": "cancercartel",
      "jolly-bijou-sapphire-sundial-ring-888234": "cancercartel",
      "spinelli-kilcollin-helio-chain-bracelet-7050480287880": "cancercartel",
      "bottega-veneta-oval-sunglasses-1137737": "cancercartel",
      "spinelli-kilcollin-helio-chain-bracelet-7050480320648": "cancercartel",
      "spinelli-kilcollin-helio-chain-necklace-7050481139848": "cancercartel",
      "zoe-lev-multi-tone-trio-band-7050369040520": "cancercartel",
      "spinelli-kilcollin-gravity-chain-necklace-7050480943240": "cancercartel",
      "blush-foil-valentina-i-love-ny-button-earrings-blush": "cancercartel",
      "rubellite-ear-cuff-yellow-gold": "cancercartel",
      "spinelli-kilcollin-orion-sg-stack-ring-7050361241736": "cancercartel",
      "natori-sapphire-brush-stroke-shangri-la-eternity-ring-7050378313864": "cancercartel",
      "pink-multicolor-foil-valentina-i-love-ny-triple-drop-earrings-multi-pink": "cancercartel",
      "la-perla-short-pajamas-1171172": "cancercartel",
      "caroline-ring-rose-gold": "cancercartel",
      "astra-ruby-ring-rose-gold": "cancercartel",
      "brienne-diamond-ring-rose-gold": "cancercartel",
      "bello-blue-ring-yellow-gold": "cancercartel",
      "la-perla-robe-1171170": "cancercartel",
      "maria-faux-shearling-coat-pale-blush": "cancercartel",
      "spinelli-kilcollin-marigold-stack-ring-7050360979592": "cancercartel",
      "spinelli-kilcollin-solarium-mx-stack-ring-7050361372808": "cancercartel",
      "serendipity-cushion-diamond-ring-rose-gold": "cancercartel",
      "nonza-ruby-earrings-ruby": "cancercartel",
      "la-perla-short-slip-dress-1171168": "cancercartel",
      "la-perla-silk-pajama-shorts-990280": "cancercartel",
      "la-perla-medium-brief-700394": "cancercartel",
      "pink-sapphire-arcadia-atoll-pendant-necklace-rose-gold": "cancercartel",
      "graziela-gems-floating-pink-sapphire-station-necklace-7480517197960": "cancercartel",
      "spinelli-kilcollin-sagittarius-ring-7050480779400": "cancercartel",
      "graziela-gems-rhodolite-3-sided-band-ring-7480517066888": "cancercartel",
      "sisley-paris-les-phyto-ombres-eyeshadows-191338": "cancercartel",
      "metallic-fuchsia-freshwater-pearl-mini-huggie-earring-fuchsia": "cancercartel",
      "graziela-gems-large-pink-sapphire-3-sided-hoop-earrings-7480517689480": "cancercartel",
      "metallic-fuchsia-small-chiara-drop-earring-fuchsia": "cancercartel",
      "spinelli-kilcollin-acacia-tri-tone-linked-ring-7310631731336": "cancercartel",
      "pink-sapphire-tube-ring-pink-sapphire": "cancercartel",
      "ruby-tube-ring-ruby": "cancercartel",
      "spinelli-kilcollin-leo-tri-tone-core-linked-ring-7310632059016": "cancercartel",
      "pink-sapphire-tube-cuff-pink-sapphire": "cancercartel",
      "ruby-mini-type-stack-ring-pink-sapphire-ruby": "cancercartel",
      "ruby-type-stack-ring-pink-sapphire-ruby": "cancercartel",
      "pink-sapphire-6th-signet-ring-pink-sapphire": "cancercartel",
      "black-diamond-ruby-core-15-drop-earrings-ruby": "cancercartel",
      "cori-raffia-sun-hat-natural-pomelo": "cancercartel",
      "baby-pink-satin-slim-moon-bag-baby-pink": "cancercartel",
      "sisleyparis-phyto-liptwisttintedbalm-20782": "cancercartel",
      "cyclamen-satin-moon-bag-cyclamen": "cancercartel",
      "pink-crystal-mesh-moon-bag-pink": "cancercartel",
      "plum-leather-moon-bag-plum": "cancercartel",
      "la-perla-hbra-underwire-no-padded-1137908": "cancercartel",
      "spinelli-kilcollin-norah-rose-linked-ring-7310632353928": "cancercartel",
      "baby-pink-leather-moon-bag-baby-pink": "cancercartel",
      "spinelli-kilcollin-capricorn-tri-tone-linked-ring-7310632288392": "cancercartel",
      "pink-sapphire-arcadia-atoll-ring-rose-gold": "cancercartel",
      "pale-pink-laminated-tiny-moon-bag-pale-pink": "cancercartel",
      "sisleyparis-lephytorouge-64676": "cancercartel",
      "spinelli-kilcollin-cancer-deux-diamond-tri-tone-linked-ring-7310632222856": "cancercartel",
      "pink-sapphire-lego-id-bracelet-pink-sapphire": "cancercartel",
      "coral-ruby-heart-pendant-necklace-pink": "cancercartel",
      "pink-sapphire-otto-bracelet-pink": "cancercartel",
      "amethyst-otto-ring-pink": "cancercartel",
      "pink-sapphire-otto-mini-huggie-earrings-pink": "cancercartel",
      "diamond-s-stairway-pendant-necklace-pink-gold": "cancercartel",
      "diamond-two-tone-my-way-pendant-necklace-pink-silver": "cancercartel",
      "diamond-anyway-double-drop-earring-pink-gold": "cancercartel",
      "pod-signet-ring-green": "cancercartel",
      "diamond-18k-rose-gold-my-way-pendant-necklace-pink-gold": "cancercartel",
      "diamond-rockaway-peak-hoop-earring-pink-gold": "cancercartel",
      "diamond-stairway-small-hoop-earring-pink-gold": "cancercartel",
      "diamond-stairway-cone-hoop-earring-pink-gold": "cancercartel",
      "diamond-stairway-pendant-necklace-pink-gold": "cancercartel",
      "roda-enamel-ruby-ring-ruby": "cancercartel",
      "ten-fourteen-ruby-petite-ring-ruby": "cancercartel",
      "plural-open-ring-pink": "cancercartel",
      "black-diamond-ruby-core-15-ring-ruby": "cancercartel",
      "diamond-three-row-stairway-ring-pink-gold": "cancercartel",
      "medium-hot-pink-leather-cloud-hot-pink": "cancercartel",
      "nebula-mismatched-drop-earrings-pink": "cancercartel",
      "diamond-half-pave-rockaway-spinner-ring-pink-gold": "cancercartel",
      "micro-pearlized-ballet-slipper-cloud-in-nappa-lambskin-pearlized-pink": "cancercartel",
      "medium-pearlized-ballet-slipper-cloud-in-nappa-lambskin-pearlized-pink": "cancercartel",
      "large-hot-pink-leather-cloud-hot-pink": "cancercartel",
      "diamond-pyramid-mini-rockaway-ring-pink-gold": "cancercartel",
      "daphne-charmeuse-mini-dress-magenta": "cancercartel",
      "micro-hot-pink-leather-cloud-hot-pink": "cancercartel",
      "large-pearlized-ballet-slipper-cloud-in-nappa-lambskin-pearlized-pink": "cancercartel",
      "sadie-raw-silk-gown-peony": "cancercartel",
      "saunder-charmeuse-gown-magenta": "cancercartel",
      "diamond-two-tone-my-way-ring-pink-silver": "cancercartel",
      "rory-gingham-midi-dress-tea-pink-gingham": "cancercartel",
      "rory-raw-silk-midi-dress-magenta": "cancercartel",
      "rachel-raw-silk-midi-dress-magenta": "cancercartel",
      "color-wave-high-ring-champagne-diamonds-champagne-diamond": "cancercartel",
      "cirrus-charmeuse-gown-magenta": "cancercartel",
      "the-weave-classic-shirt-rose-pink": "cancercartel",
      "black-agate-18k-rose-gold-mini-spike-ring-pink-gold": "cancercartel",
      "the-weekend-seersucker-shirt-pink": "cancercartel",
      "so-wavy-stone-hoops-pink-colorway-pink": "cancercartel",
      "three-bezel-drop-necklace-pink-colorway-pink": "cancercartel",
      "diamond-18k-rose-gold-mini-my-way-ring-pink-gold": "cancercartel",
      "channel-set-wide-band-pink-sapphire-pink": "cancercartel",
      "diamond-two-tone-mini-my-way-ring-pink-silver": "cancercartel",
      "wide-huggies-pink-sapphire-pink": "cancercartel",
      "so-wavy-ring-champagne-diamonds-champagne": "cancercartel",
      "hinged-swing-earrings-pink-colorway-pink": "cancercartel",
      "so-wavy-heart-huggies-pink-sapphires-pink": "cancercartel",
      "the-boyfriend-linen-shirt-grapefruit-pink": "cancercartel",
      "blush-lily-drop-earrings-blush-pink": "cancercartel",
      "diamond-top-handle-bag-natural-candy-pink-gold": "cancercartel",
      "al-tair-fringe-bag-rose": "cancercartel",
      "pink-sapphire-large-pill-pendant-necklace-pink": "cancercartel",
      "pink-sapphire-medium-pill-bracelet-pink": "cancercartel",
      "pink-sapphire-pill-stud-earrings-pink": "cancercartel",
      "ten-fourteen-shaker-ring-white": "cancercartel",
      "carter-cashmere-beret-blush": "cancercartel",
      "koda-crystal-bag-pink-shimmer": "cancercartel",
      "frances-cashmere-beanie-blush": "cancercartel",
      "scarab-and-pearl-bangle-gold-green": "cancercartel",
      "pink-opal-alligator-bite-earring-gold-pink": "cancercartel",
      "mini-jellyfish-white-pearl-stud-gold-white": "cancercartel",
      "essentials-long-hot-pink-hot-pink": "cancercartel",
      "mini-scarab-mammoth-stud-gold-white": "cancercartel",
      "mini-scarab-mammoth-stud-mirror-rose-gold-white": "cancercartel",
      "mermaid-splash-earring-in-dual-tone-gold-rose-gold": "cancercartel",
      "the-depths-of-time-drop-earrings-pink": "cancercartel",
      "pink-sapphire-found-cap-chandelier-drop-earrings-pink-sapphires": "cancercartel",
      "camila-popcorn-knit-sweater-claret": "cancercartel",
      "turquoise-pink-sapphire-found-cabochon-huggie-earrings-pink-sapphires-turquoise": "cancercartel",
      "pink-sapphire-juju-heart-charm-huggie-earrings-pink-sapphire": "cancercartel",
      "turquoise-pink-sapphire-found-large-disk-pendant-necklace-pink-sapphire-turquoise": "cancercartel",
      "tokyo-ginko-burgundy-cotton-pajama-set-burgundy": "cancercartel",
      "pink-sapphire-found-cap-huggie-earrings-pink-sapphires": "cancercartel",
      "pink-sapphire-spark-chevron-link-drop-earrings-pink-sapphires": "cancercartel",
      "turquoise-pink-sapphire-found-cap-huggie-earrings-turquoise": "cancercartel",
      "sleeveless-wind-top-dusty-pink": "cancercartel",
      "pink-sapphire-found-ribbed-huggie-earrings-pink-sapphires": "cancercartel",
      "pink-sapphire-crew-small-circle-pendant-necklace-pink-sapphire": "cancercartel",
      "juju-crown-pendant-necklace-yellow-pink-sapphires": "cancercartel",
      "pink-sapphire-diamond-crew-tube-drop-earrings-pink-sapphires": "cancercartel",
      "ricia-95-platform-sandal-candy-pink-natural": "cancercartel",
      "ten-fourteen-petite-ring-white": "cancercartel",
      "bing-100-pink-mix": "cancercartel",
      "sparkle-paillette-disc-nano-bag-pink-gold-silver": "cancercartel",
      "diamond-light-pink-enamel-18k-gold-comete-stud-earrings-pink": "cancercartel",
      "diamond-fuchsia-enamel-18k-white-gold-twinkle-star-stud-earrings-pink": "cancercartel",
      "romy-85-rose": "cancercartel",
      "pink-enamel-18k-gold-cuff-bracelet-pink": "cancercartel",
      "rubellite-18k-rose-gold-stamp-bracelet-rose-gold": "cancercartel",
      "daphne-silk-charmeuse-asymmetric-ruffle-gown-tea-pink": "cancercartel",
      "pink-tourmaline-18k-rose-gold-two-tone-bolt-pendant-necklace-pink": "cancercartel",
      "pink-sapphire-18k-rose-gold-baby-bolt-pendant-necklace-rose-gold": "cancercartel",
      "martine-satin-plunge-bubble-mini-dress-pink": "cancercartel",
      "verona-ballet-pink-crystal": "cancercartel",
      "pink-sapphire-18k-rose-gold-baby-bolt-bracelet-rose-gold": "cancercartel",
      "akoya-pearl-18k-rose-gold-pampille-hoop-drop-earrings-rose-gold": "cancercartel",
      "pink-spinel-18k-rose-gold-two-tone-pampille-drop-earrings-rose-gold-pink": "cancercartel",
      "cristobal-leopard-brushed-wool-cashmere-blanket-scarf-pink": "cancercartel",
      "amethyst-sapphire-14k-gold-sunset-revival-pendant-necklace-pink": "cancercartel",
      "diamond-14k-gold-mini-frame-pendant-necklace-pink": "cancercartel",
      "pink-tourmaline-14k-gold-lotus-charm-pink": "cancercartel",
      "pink-opal-14k-gold-always-intentions-charm-pink": "cancercartel",
      "pink-opal-14k-gold-palace-bead-drop-earrings-pink": "cancercartel",
      "bing-100-macaron-mix": "cancercartel",
      "jenn-stripe-brushed-wool-cashmere-crewneck-sweater-turquoise": "cancercartel",
      "jenn-stripe-brushed-wool-cashmere-crewneck-sweater-red": "cancercartel",
      "dave-recycled-knit-ribbed-zip-cardigan-pink": "cancercartel",
      "pink-sapphire-diamond-crew-stacking-band-ring-pink": "cancercartel",
      "rei-stripe-wool-crewneck-sweater-multi": "cancercartel",
      "mireille-recycled-knit-button-up-cardigan-pink": "cancercartel",
      "pink-18k-white-gold-diamond-small-chiara-drop-earring-metallic-pink": "cancercartel",
      "turquoise-pink-sapphire-found-ribbed-cocktail-ring-pink-sapphires": "cancercartel",
      "sheer-mesh-ruched-drape-maxi-skirt-fuschia": "cancercartel",
      "drea-puff-sleeve-taffeta-mini-dress-magenta": "cancercartel",
      "semi-sheer-mesh-v-neck-bodysuit-fuschia": "cancercartel",
      "semi-sheer-mesh-mock-neck-bodycon-jumpsuit-fuschia": "cancercartel",
      "bella-floral-silk-smocked-midi-skirt-lehua-sunset": "cancercartel",
      "robe-light-pink": "cancercartel",
      "olesia-tiered-taffeta-halter-gown-ultra-pink": "cancercartel",
      "red-lace-agate-pink-bio-resin-sterling-silver-drop-earrings-pink": "cancercartel",
      "sunrise-hand-dyed-silk-kaftan-maxi-dress-orange-peach": "cancercartel",
      "fiore-floral-silk-pleated-a-line-maxi-dress-lehua-sunset": "cancercartel",
      "tolan-floral-silk-gathered-button-up-shirt-lehua-sunset": "cancercartel",
      "georgia-floral-silk-ruffle-collar-top-lehua-sunset": "cancercartel",
      "tova-floral-silk-sleeveless-maxi-dress-lehua-sunset": "cancercartel",
      "isidora-asymmetric-fringe-maxi-dress-peach": "cancercartel",
      "the-oversized-oxford-cotton-button-up-shirt-rose-pink": "cancercartel",
      "sac-a-main-evening-bag-pink-silver": "cancercartel",
      "robe-peach-blush": "cancercartel",
      "long-dress-powder-pink-silver": "cancercartel",
      "the-boyfriend-stripe-tencel-exaggerated-cuff-button-up-shirt-burgundy-stripe": "cancercartel",
      "diamond-light-pink-enamel-18k-gold-band-ring-pink": "cancercartel",
      "diamond-pink-enamel-wish-box-hope-pendant-necklace-silver-and-pink": "cancercartel",
      "the-classic-oxford-cotton-button-up-shirt-rose-pink": "cancercartel",
      "ruby-18k-gold-core-15-antiqued-pendant-necklace-ruby": "cancercartel",
      "ruby-18k-gold-naipe-heart-ish-pendant-ruby": "cancercartel",
      "rosa-dress-pink-serenade": "cancercartel",
      "the-palazzo-stripe-seersucker-cotton-pull-on-pants-grapefruit-pink-stripe": "cancercartel",
      "hurry-up-slow-down-embroidered-crewneck-sweater-magenta": "cancercartel",
      "diamond-18k-gold-core-12-shaker-pendant-necklace-yellow-gold": "cancercartel",
      "diamond-18k-gold-ten-fourteen-petite-pendant-necklace-yellow-gold": "cancercartel",
      "pink-tourmaline-diamond-18k-gold-fairy-dust-pendant-necklace-gold": "cancercartel",
      "pink-sapphire-18k-gold-elara-ombre-ear-cuff-yellow-gold": "cancercartel",
      "pink-tourmaline-18k-gold-bubble-infinity-ring-gold": "cancercartel",
      "pink-sapphire-blush-rosa-petal-stud-earrings-pink": "cancercartel",
      "pink-sapphire-mini-heart-stud-earrings-pink": "cancercartel",
      "pink-sapphire-18k-gold-argo-ombre-demi-hoop-earrings-yellow-gold-rose-gold": "cancercartel",
      "fuchsia-pink-sapphire-halia-stud-earrings-pink": "cancercartel",
      "padparadscha-sapphire-infinity-necklace-multi": "cancercartel",
      "jackie-cotton-v-neck-maxi-dress-sea-glass-pink": "cancercartel",
      "lily-sheer-chiffon-flutter-sleeve-maxi-dress-sea-glass-chiffon-pink": "cancercartel",
      "lola-floral-halter-maxi-dress-rose-bandana": "cancercartel",
      "kate-floral-asymmetric-wrap-maxi-dress-rose-bandana": "cancercartel",
      "iris-floral-button-up-peasant-top-rose-bandana": "cancercartel",
      "sammie-floral-silk-pleated-button-front-maxi-dress-bougainvillea-mother-of-pearl": "cancercartel",
      "fiore-floral-pleated-maxi-dress-rose-bandana": "cancercartel",
      "the-weekend-hemp-button-up-shirt-blush-pink": "cancercartel",
      "rose-quartz-diamond-sakura-ring-pink": "cancercartel",
      "ashley-floral-silk-tie-neck-top-bougainvillea-mother-of-pearl": "cancercartel",
      "fiore-floral-silk-pleated-maxi-dress-bougainvillea-mother-of-pearl": "cancercartel",
      "kate-silk-asymmetric-wrap-maxi-dress-sea-glass-pink": "cancercartel",
      "ella-cotton-gathered-puff-sleeve-top-sea-glass-pink": "cancercartel",
      "jasmine-floral-silk-pintucked-tiered-maxi-dress-bougainvillea-mother-of-pearl": "cancercartel",
      "tova-cotton-belted-sleeveless-maxi-dress-sea-glass-pink-coral": "cancercartel",
      "demetria-crepe-draped-cape-maxi-dress-fuchsia": "cancercartel",
      "naomi-sheer-chiffon-ruffle-tiered-maxi-dress-sea-glass-chiffon-pink": "cancercartel",
      "phinia-abstract-satin-tiered-mini-dress-begoma-dewberry": "cancercartel",
      "amelia-floral-tie-neck-crop-top-rose-bandana": "cancercartel",
      "alice-sheer-chiffon-v-neck-maxi-dress-sea-glass-chiffon-pink": "cancercartel",
      "nico-floral-belted-sleeveless-maxi-dress-rose-bandana": "cancercartel",
      "ariana-sheer-chiffon-tank-top-sea-glass-chiffon-pink": "cancercartel",
      "pink-sapphire-18k-gold-petunia-ombre-linked-ring-yellow-gold": "cancercartel",
      "serata-sequin-halter-maxi-dress-pink": "cancercartel",
      "alayna-sequin-sleeveless-mini-dress-sorbet-sequin": "cancercartel",
      "leilani-sequin-strapless-column-gown-sorbet-sequin": "cancercartel",
      "sol-bralette-bikini-top-pink": "cancercartel",
      "mexico-low-rise-bikini-bottoms-pink": "cancercartel",
      "antoinette-one-piece-pink": "cancercartel",
      "morganite-14k-rose-gold-large-star-hoop-earrings-pink": "cancercartel",
      "diamond-morganite-two-tone-crivell-huggie-bracelet-pink": "cancercartel",
      "crystal-silk-blouse-pink": "cancercartel",
      "opal-morganite-ladybug-pendant-pink": "cancercartel",
      "morganite-14k-rose-gold-small-star-hoop-earrings-pink": "cancercartel",
      "maite-crepe-asymmetric-cape-midi-dress-pink": "cancercartel",
      "saucy-minx-strapless-dress-pink": "cancercartel",
      "priority-draping-ruffle-gown-pink": "cancercartel",
      "contentment-one-shoulder-gown-pink": "cancercartel",
      "fervor-strapless-dress-pink": "cancercartel",
      "jimi-pink-cotton-duster-pink": "cancercartel",
      "diamond-18k-gold-esmeralda-shaker-ring-yellow-gold": "cancercartel",
      "sleeveless-cocktail-dress-slipper": "cancercartel",
      "cecilie-bahnsen-bega-floral-applique-wool-mock-neck-sweater-pink": "cancercartel",
      "francisco-arce-myka-embellished-tulle-strapless-gown-pink": "cancercartel",
      "cecilie-bahnsen-gus-sequin-floral-sheer-tulle-pencil-skirt-pink": "cancercartel",
      "cecilie-bahnsen-vilma-floral-matelasse-babydoll-dress-pink": "cancercartel",
      "cecilie-bahnsen-utania-floral-sequin-sheer-tulle-sleeveless-top-pink": "cancercartel",
      "collections/the-pink-edit": "cancercartel",
      "green-paco-leather-bag-khaki-gold": "wfwi"
    };

    function applyDesignerCauseAssociation() {
      var path = window.location.pathname;
      var currentCause = getCookie('user_cause');

      var keys = Object.keys(DESIGNER_CAUSE_ASSOCIATION);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var cause = DESIGNER_CAUSE_ASSOCIATION[key];
        if (path.includes('/designer-' + key) || path.includes('/' + key)) {
          // Skip if cookie already set to this cause
          if (currentCause === cause) break;
          // Set the cause cookie directly
          var causeName = (window.CAUSE_MAP && window.CAUSE_MAP[cause]) || cause;
          setCauseCookies(causeName, cause, defaultShortCode);
          if (getCookie('user_cause_wj')) {
            setCookie('user_cause_wj', cause, 30);
          }
          if (getCookie('user_cause_name_wj')) {
            setCookie('user_cause_name_wj', causeName, 30);
          }
          // Notify components to re-render with the new cause once DOM is ready
          document.addEventListener('DOMContentLoaded', function() {
            document.dispatchEvent(new CustomEvent('causeChanged', { detail: { shortCode: cause } }));
          });
          return;
        }
      }
    }

    applyDesignerCauseAssociation();

    // ---- Boot
    bindPdp();
    bindCart();
    document.addEventListener('DOMContentLoaded', () => {
      //apply cause if logged in and if cause param is set in the URL
      const params = new URLSearchParams(window.location.search);
      const urlCause = params.get('cause'); // short_code or handle

      const handle = getCookieHandle();

      // If user is logged in and has a cause handle, but it's not present in CAUSE_MAP_OBJ, set to default
      if(urlCause){
        window.IS_LOGGED_IN && applyCause(urlCause);

        // reload the page without the cause param in the URL
        const url = new URL(window.location.href);
        url.searchParams.delete('cause');
        window.history.replaceState({}, document.title, url.toString());
        window.location.reload();

      }else if(window.IS_LOGGED_IN && window.CUSTOMER_CAUSE_HANDLE ) {
        if (!window.CAUSE_MAP_OBJ[window.CUSTOMER_CAUSE_HANDLE]) {
          // User's cause is not present (inactive/draft), set to default
          applyCause(window.DEFAULT_CAUSE_HANDLE);
        }else if(window.CUSTOMER_CAUSE_HANDLE != handle){
            applyCause(handle);
        }
      }else if (window.IS_LOGGED_IN && window.CUSTOMER_CAUSE_HANDLE == null && window.DEFAULT_CAUSE_HANDLE){ 
        applyCause(handle);
      }
    });

    // Listening for the custom event
    document.addEventListener('causeChanged', function (event) {
        
        bindPdp();

      // Rebind cart preview listeners if cart UI is present (drawer or full cart page).
      bindCart();
    
        //update user's cause selection in the metafields
        if(window.IS_LOGGED_IN){
            applyCause(event.detail.shortCode);
        }
        // Perform actions based on the event
        // Example: Update the DOM or trigger another function
    });

    // Rebind/refresh cart preview for theme cart lifecycle events.
    document.addEventListener('quantity-selector:update', () => setTimeout(bindCart, 250));
    document.addEventListener('cart:update', () => setTimeout(bindCart, 150));

    // Delegated click fallback: handles nested SVG/span taps on mobile quantity and remove controls.
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const cartActionButton = target.closest('cart-quantity-selector-component button[name="plus"], cart-quantity-selector-component button[name="minus"], .cart-items__remove');
      if (!cartActionButton) return;

      setTimeout(bindCart, 350);
    });

    // Call bindCart when the cart drawer opens (e.g. after Add to Cart on PDP)
    (function() {
      let cartDrawerOpenTimer = null;
      let lastCartDrawerOpenAt = 0;

      function onCartDrawerOpen() {
        const now = Date.now();
        if (now - lastCartDrawerOpenAt < 300) return;
        lastCartDrawerOpenAt = now;

        // Small delay to allow drawer content to finish rendering
        if (cartDrawerOpenTimer) clearTimeout(cartDrawerOpenTimer);
        cartDrawerOpenTimer = setTimeout(bindCart, 200);
      }

      function attachCartDrawerObserver() {
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (!cartDrawer) return;
        new MutationObserver((mutations) => {
          for (const m of mutations) {
            if (m.attributeName === 'open' && cartDrawer.hasAttribute('open')) {
              onCartDrawerOpen();
            }
          }
        }).observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attachCartDrawerObserver);
      } else {
        attachCartDrawerObserver();
      }

      // Fallback for themes that dispatch a custom event instead of toggling an attribute
      document.addEventListener('cart-drawer:opened', onCartDrawerOpen);
    })();
  })();
